import Vue from 'vue'
import { domain, redmineDomain, redmineApiKey } from 'src/app_config'
import _ from 'lodash'
// import { redmineDomain, redmineApiKey } from 'src/app_config'

// const url = api => 'http://dghk1gisap001/redmine' + api
const url = api => redmineDomain + '/smeeredmine' + api
const commonServiceUrl = api => domain + '/common' + api

const requestOptions = {
  headers: {
    'X-Redmine-API-Key': redmineApiKey
    // 'X-Redmine-API-Key': '3aed4f15fa3d47e8585cf99b82d753613af3b99d'
  }
}

const rejectResponse = (reject, response) => {
  let message = response.body || response.body.message || response.body.error || 'Failed'
  reject({ message })
}

const updateIssueOneByOne = function ({ issues, idx, oneDone, allDone, onFailed }) {
  if (idx === undefined) {
    idx = 0
  }
  if (idx < issues.length) {
    let issue = issues[idx]
    Vue.http.put(url('/issues/' + issue.id + '.json'), {
      issue: {...issue.data}
    }, requestOptions).then(() => {
      oneDone(issue)
    }).catch(() => {
      onFailed(issue)
    }).then(() => {
      idx++
      updateIssueOneByOne({ issues, idx, oneDone, allDone, onFailed })
    })
  } else {
    allDone()
  }
}

export const getCustomFields = function () {
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/custom_fields.json'), requestOptions).then(response => {
      let customFields = response.body['custom_fields'].filter(customField => {
        return customField['customized_type'] === 'issue'
      }).map(customField => {
        let list = customField['possible_values'] ? customField['possible_values'].map(item => {
          return {
            id: item['value'],
            name: item['label']
          }
        }) : undefined
        return {
          field: customField['id'],
          name: customField['name'],
          list: list,
          defaultValue: customField['default_value']
        }
      })
      let rawCustomFields = response.body['custom_fields']
      resolve({
        customFields,
        rawCustomFields
      })
    }, response => {
      rejectResponse(reject, response)
    })
  })
}

export const getCustomFieldMap = function () {
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/custom_fields.json'), requestOptions).then(response => {
      let customFieldMap = {}
      response.body['custom_fields'].forEach((customField) => {
        if (customField['customized_type'] === 'issue') {
          const fieldName = customField['name']
          customFieldMap[fieldName] = {
            id: customField['id']
          }
          if (customField['possible_values']) {
            customFieldMap[fieldName]['values'] = customField['possible_values']
          }
        }
      })
      resolve(customFieldMap)
    }, response => {
      rejectResponse(reject, response)
    })
  })
}

export const getStatuses = function () {
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/issue_statuses.json'), requestOptions).then(response => {
      let result = response.body
      if (result['issue_statuses']) {
        let statuses = result['issue_statuses'].map(status => {
          return {
            ...status,
            isDefault: status.name === 'New',
            isClosed: status['is_closed'] === true
          }
        })
        resolve(statuses)
      } else {
        rejectResponse(reject, response)
      }
    }, response => {
      rejectResponse(reject, response)
    })
  })
}

export const getProjects = function () {
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/projects.json'), requestOptions).then(response => {
      let projects = response.body.projects
      if (projects) {
        resolve(projects)
      } else {
        rejectResponse(reject, response)
      }
    }, response => {
      rejectResponse(reject, response)
    })
  })
}

export const getPriorities = function () {
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/enumerations/issue_priorities.json'), requestOptions).then(response => {
      let priorities = response.body['issue_priorities'] ? response.body['issue_priorities'].map(priority => {
        return {
          id: priority['id'],
          name: priority['name'],
          isDefault: priority['is_default'] === true
        }
      }) : undefined
      if (priorities) {
        resolve(priorities)
      } else {
        rejectResponse(reject, response)
      }
    }, response => {
      rejectResponse(reject, response)
    })
  })
}

export const getTrackers = function () {
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/trackers.json'), requestOptions).then(response => {
      let trackers = response.body['trackers'] ? response.body['trackers'].map(tracker => {
        return {
          id: tracker['id'],
          name: tracker['name'],
          isDefault: tracker['id'] === tracker['default_status']['id']
        }
      }) : undefined
      if (trackers) {
        resolve(trackers)
      } else {
        rejectResponse(reject, response)
      }
    }, response => {
      rejectResponse(reject, response)
    })
  })
}

export default {
  created () {
    this.$redmine = {}

    this.$redmine.getCustomFieldMap = getCustomFieldMap

    this.$redmine.createRequests = params => {
      const promise = new Promise((resolve, reject) => {
        const project = params.project
        const subject = params.subject
        const type = params.type
        const subType = params.subType
        const refNoList = params.refNoList
        const refType = params.refType
        const batchId = params.batchId
        const detail = params.detail
        const tracker = params.tracker
        const status = params.status
        const priority = params.priority
        const vendorName = params.vendorName
        const vendorName2 = params.vendorName2
        const vendorCode = params.vendorCode
        const shipCancelDate = params.shipCancelDate
        const indcDate = params.indcDate
        const coo = params.coo
        const brand = params.brand
        const token = params.token
        if (refNoList.value.length === 0) {
          reject()
        }
        // console.log(refNoList)
        Promise.all([
          this.$http.post(url('/batchids.json'), {
            batchid: {
              prefix: 'R',
              base: 1000000
            }
          }, requestOptions),
          this.$http.get(commonServiceUrl('/poAdditionalInfo'), {
            headers: {
              'Authorization': 'Bearer ' + token
            },
            params: {
              poNumbers: refNoList.value.join(',')
            }
          })
        ]).then((responses) => {
          const result = responses[0].body
          const additionalInfoMap = responses[1].body
          // const vendorInfo = {
          //   vendorName: 'Vendor Name',
          //   vendorCode: 'Vendor Code'
          // }
          batchId.value = result.batchid.prefix + (result.batchid.base + result.batchid.id)

          let requests = []
          refNoList.value.forEach((refNo) => {
            let issue = {}
            let additionalInfo = additionalInfoMap[refNo] || {}
            issue[project.id] = project.value
            issue[subject.id] = refNo + ' ' + subType.value
            issue[tracker.id] = tracker.value // Default 'Feature' in Redmine
            issue[status.id] = status.value
            issue[priority.id] = priority.value // Default 'Normal' in Redmine
            issue['custom_field_values'] = {}
            let cf = issue['custom_field_values']
            cf[type.id] = type.value
            cf[subType.id] = subType.value
            cf[refNoList.id] = refNo
            cf[refType.id] = refType.value
            cf[batchId.id] = batchId.value
            cf[detail.id] = detail.value
            cf[vendorName.id] = vendorName.value
            if (additionalInfo) {
              cf[vendorName2.id] = additionalInfo.vendorName
              cf[vendorCode.id] = additionalInfo.vendorCode
              cf[shipCancelDate.id] = additionalInfo.currShipCancelDate
              cf[indcDate.id] = additionalInfo.currIndcDate
              cf[coo.id] = additionalInfo.coo
              cf[brand.id] = additionalInfo.brand
            }
            const request = this.$http.post(url('/issues.json'), {
              issue: issue
            }, requestOptions)
            requests.push(request)
          }, this)
          Promise.all(requests).then((issues) => {
            resolve({
              issues,
              batchId: batchId.value
            })
          }).catch((reason) => {
            reject(reason)
          })
        }, (response) => {
          reject(response)
        })
      })
      return promise
    }

    this.$redmine.searchRequests = ({ params }) => {
      return new Promise((resolve, reject) => {
        let api
        let option
        if (params.id) {
          api = url('/issues/' + params.id + '.json')
          option = requestOptions
        } else {
          api = url('/issues.json')
          params = {...params, limit: 100}
          option = {...{params}, ...requestOptions}
        }
        const getIssues = ({ offset, limit }) => {
          let optionCopy = _.cloneDeep(option)
          optionCopy.params.offset = offset
          optionCopy.params.limit = limit
          return Vue.http.get(api, optionCopy)
        }
        Vue.http.get(api, option).then(response => {
          // let issues = response.body.issues ? response.body.issues : [response.body.issue]
          if (params.id) {
            resolve([response.body.issue])
          } else {
            let { issues, limit } = response.body
            let totalCount = response.body['total_count']
            if (issues.length < totalCount) {
              let requestCount = Math.ceil(totalCount * 1.0 / limit)
              let requests = []
              for (let i = 0; i < requestCount; i++) {
                requests.push(getIssues({
                  offset: limit * i,
                  limit
                }))
              }
              Promise.all(requests).then(responses => {
                let issues = responses.reduce((issues, response) => {
                  issues.push(...response.body.issues)
                  return issues
                }, [])
                resolve(issues)
              })
            } else {
              resolve(issues)
            }
          }
        }).catch(response => {
          resolve([])
        })
      })
    }

    this.$redmine.retrieveAllIssues = ({ params }) => {
      const getIssues = ({ offset }) => {
        return Vue.http.get(url('/issues.json'), {
          params: {
            ...params,
            offset,
            limit: 100
          }
        })
      }
      return new Promise((resolve, reject) => {
        getIssues({ offset: 0 }).then(response => {
          let { issues, limit } = response.body
          let totalCount = response.body['total_count']
          if (issues.length < totalCount) {
            let requestCount = Math.ceil(totalCount * 1.0 / limit)
            let requests = []
            for (let i = 0; i < requestCount; i++) {
              requests.push(getIssues({
                offset: limit * i
              }))
            }
            Promise.all(requests).then(responses => {
              let issues = responses.reduce((issues, response) => {
                issues.push(...response.body.issues)
                return issues
              }, [])
              resolve(issues)
            }).catch(() => {
              reject([])
            })
          } else {
            resolve(issues)
          }
        }).catch(response => {
          reject([])
        })
      })
    }

    this.$redmine.updateIssues = (issues) => {
      return new Promise((resolve, reject) => {
        let issuesSuccess = []
        let issuesFailed = []
        updateIssueOneByOne({
          issues,
          oneDone (issue) {
            issuesSuccess.push(issue.id)
          },
          onFailed (issue) {
            issuesFailed.push(issue.id)
          },
          allDone () {
            resolve({
              success: issuesSuccess,
              failed: issuesFailed
            })
          }
        })
      })
    }

    this.$redmine.updateIssue = ({ issue }) => {
      return Vue.http.put(url('/issues/' + issue.id + '.json'), {
        issue: issue.data
      }, requestOptions)
    }

    this.$redmine.getIssue = ({ id }) => {
      return new Promise((resolve, reject) => {
        Vue.http.get(url('/issues/' + id + '.json?include=journals'), requestOptions).then(response => {
          resolve(response.body.issue)
        }).catch(response => {
          reject({ message: response.statusText })
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/redmine/index.js